import { useState } from 'react';
import { CustomerGroupType } from '@/types/schemas';

const useData = (defaultGroup: CustomerGroupType) => {
  const [activeGroup, setActiveGroup] = useState<CustomerGroupType>(defaultGroup);
  const handleFilter = (groupType: CustomerGroupType) => {
    setActiveGroup(groupType);
  };

  return {
    activeGroup,
    handleFilter
  };
};

export default useData;
